import {BleskIcon} from '@blesk-frontend/ui';
import {createElement, ReactNode} from 'react';

interface PlanCardProps {
  children: ReactNode;
  name: ReactNode;
  icon?: BleskIcon;
}

export const PlanCard = ({children, name, icon}: PlanCardProps) => {
  return (
    <div className="flex flex-col gap-4 rounded-lg border bg-bg-secondary p-6">
      <div className="flex items-center gap-2 text-text-primary text-title-h2">
        {name}
        {icon && createElement(icon, {className: 'size-6 text-brand-primary'})}
      </div>
      <div className="flex h-full flex-col gap-4 text-paragraph-md text-text-primary">
        {children}
      </div>
    </div>
  );
};
